import { useRef, useEffect } from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { createRoot } from "react-dom/client";
import Popover from "./Popover";
import { Backdrop, CircularProgress } from "@mui/material";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function Map({ style, loading, rows, onClick }) {
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    const updateMarkers = () => {
      map.current.loadImage("/marker.png", (error, image) => {
        if (error) throw error;
        if (map.current.getSource("points")) {
          map.current.removeLayer("unclustered-point");
          map.current.removeSource("points");
        }
        map.current.addSource("points", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: rows.map((_) => ({
              type: "Feature",
              properties: _,
              geometry: {
                type: "Point",
                coordinates: [_.longitude, _.latitude],
              },
            })),
          },
        });
        map.current.addLayer({
          id: "unclustered-point",
          type: "circle",
          source: "points",
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": "#5628D2",
            "circle-radius": 4,
            "circle-stroke-width": 1,
            "circle-stroke-color": "#fff",
          },
        });

        map.current.on("click", "unclustered-point", (e) => {
          const coordinates = e.features[0].geometry.coordinates.slice();
          while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
          }
          const popupNode = document.createElement("div");
          const root = createRoot(popupNode);
          root.render(
            <Popover properties={e.features[0].properties} onClick={onClick} />
          );
          new mapboxgl.Popup()
            .setLngLat(coordinates)
            .setDOMContent(popupNode)
            .addTo(map.current);
        });
        const bounds = new mapboxgl.LngLatBounds();
        rows.forEach((feature) => {
          if (feature.longitude && feature.latitude) {
            bounds.extend([feature.longitude, feature.latitude]);
          }
        });
        if (rows.length) {
          map.current.fitBounds(bounds, { padding: 100, duration: 0 });
        }
      });
    };
    if (!map.current) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/adamtsouras99/ckqws2w4w22el17mz13csjm0i",
        center: [-98.5795, 39.8283],
        zoom: 4,
        preserveDrawingBuffer: true,
      });
      map.current.on("load", () => {
        updateMarkers();
      });
    } else {
      updateMarkers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  return (
    <div style={{ ...style, height: "100%", width: "100%" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div ref={mapContainer} style={{ height: "100%", width: "100%" }} />
    </div>
  );
}
